import { Modal } from "@material-ui/core";
import "./ComplianceForm.scss";
import React from "react";
import Typography from "../Typography/Typography";
import { Form } from "antd";
import StepPanel from "./StepPanel";
import Step1Form from "./Step1Form";
import Step2Form from "./Step2Form";
import Step3Form from "./Step3Form";

import Icons from "../Icons/Icons";
import { DOMAIN_NOT_HTTPS, EMPTY_REQUIRED_FIELD_MESSAGE, IP_REGEX, LOCALHOST_REGEX, NOT_A_VALID_DOMAIN, URL_REGEX } from "../../constants/constants";
import { useState } from "react";

const ComplianceForm = ({ open, onClose, setIsComplianceFormFilled }) => {
  const [stepForm] = Form.useForm();

  const urlRules = [
    {
      validator: (_, value) => {
        if (value != undefined) {
          if (value === "") {
            return Promise.reject(EMPTY_REQUIRED_FIELD_MESSAGE);
          }
          if (!value.startsWith("https://")) {
            return Promise.reject(DOMAIN_NOT_HTTPS);
          }
          Promise.resolve();
        }
      },
    },
  ];

  const emptyInputRule = [
    {
      validator: (_, value) => {
        if (value != undefined) {
          if (value === "") {
            return Promise.reject(EMPTY_REQUIRED_FIELD_MESSAGE);
          }
          Promise.resolve();
        }
      },
    },
  ];

  const steps = [
    {
      step: 1,
      content: <Step1Form formInstance={stepForm} urlRules={urlRules} emptyInputRule={emptyInputRule} />,
    },
    {
      step: 2,
      content: <Step2Form formInstance={stepForm} urlRules={urlRules} emptyInputRule={emptyInputRule} />,
    },
    {
      step: 3,
      content: <Step3Form formInstance={stepForm} onClose={onClose} setIsComplianceFormFilled={setIsComplianceFormFilled} />,
    },
  ];

  if (!open) {
    return null;
  }

  const handleCloseForm = () => {
    onClose();
    stepForm.resetFields();
  };

  return (
    <div className="modal">
      <div className="compliance-form-container">
        <div className="compliance-form-info-container">
          <div className="compliance-form-info-content">
            <h3 className="compliance-form-info-heading">Contact us to access production credentials</h3>
            <div className="compliance-form-info-description">
              <p>✦&nbsp;</p>
              <p style={{ width: "100%" }}>Connect real accounts and fetch real data.</p>
            </div>
            <div className="compliance-form-info-description" style={{ marginTop: "12px" }}>
              <p>✦&nbsp;</p>
              <p style={{ width: "100%" }}>250 account connections free, forever.</p>
            </div>
            <div className="compliance-form-info-description-section-container">
              <div>
                <p className="compliance-form-info-description-section">Provide a few details to help us get back to you.</p>
              </div>
              <div className="arrow-icon">
                <Icons.arrow_form />
              </div>
            </div>
            <div className="compliance-form-info-description-section-container">
              <p className="compliance-form-info-description-section" style={{ marginRight: "35px" }}>
                Got questions? Email{" "}
                <a href="mailto:support@getphyllo.com" style={{ cursor: "pointer" }}>
                  <u>support@getphyllo.com</u>
                </a>{" "}
              </p>
            </div>
          </div>
          <div className="left-background" />
          <div className="right-background" />
        </div>
        <div className="compliance-form-content">
          <div className="close-icon-container">
            <Icons.close_circle_fill onClick={handleCloseForm} cursor="pointer" />
          </div>
          <Form form={stepForm}>
            <StepPanel steps={steps} formInstance={stepForm} />
          </Form>
        </div>
      </div>
    </div>
  );
};

export default ComplianceForm;
